import React from "react";

import {
    CalendarField, DSGVOCheckbox,
    Form,
    InputField,
    SubmitButton,
} from "../Form/Form";

import {__} from "@wordpress/i18n";
import {getSetting} from "../utils/settings";
import {submitForm} from "../api/requests";

const hasMinLength = (value: string, minLength: number): boolean =>
    value.trim().length >= minLength;

const isEmail = (value: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

const isFutureIsoDate = (value: string): boolean => {
    const parsed = Date.parse(value);

    if (Number.isNaN(parsed)) {
        return false;
    }

    const selected = new Date(parsed);
    selected.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selected >= today;
};

export function AppointmentForm({text}: ({ text: string })): React.ReactElement {
    const onSubmit = async (event: SubmitEvent): Promise<void> => {
        event.preventDefault();

        const form = event.target as HTMLFormElement | null;

        if (!form) {
            return;
        }

        const formData = new FormData(form);

        await submitForm('appointment-form', {
            company: (formData.get('company') ?? '').toString(),
            name: (formData.get('name') ?? '').toString(),
            email: (formData.get('email') ?? '').toString(),
            appointment: (formData.get('appointment') ?? '').toString(),
            dsgvo: formData.has('dsgvo'),
        });
    };

    return (
        <>
            <p>{text}</p>
            <div className="wvcb-card">
                <div className="wvcb-appointment-form">
                    <Form onSubmit={onSubmit}>
                        <div className="container grid wrap">
                            <div className="column column--md-6">
                                <InputField
                                    label={__('Unternehmen', 'wv-chat-bot')}
                                    name="company"
                                    required
                                    validate={(value) => hasMinLength(value, 2)}
                                    validationMessage={__('Bitte einen gueltigen Unternehmensnamen eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column column--md-6">
                                <InputField
                                    label={__('Vor- und Nachname', 'wv-chat-bot')}
                                    name="name"
                                    required
                                    validate={(value) => value.trim().split(/\s+/).length >= 2}
                                    validationMessage={__('Bitte Vor- und Nachname eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column">
                                <InputField
                                    label={__('E-Mail', 'wv-chat-bot')}
                                    name="email"
                                    type="email"
                                    required
                                    validate={isEmail}
                                    validationMessage={__('Bitte eine gueltige E-Mail-Adresse eingeben.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column">
                                <CalendarField
                                    label="Termin"
                                    name="appointment"
                                    required
                                    daysInFuture={getSetting('appointment_form.days_in_future')}
                                    allowedWeekdays={getSetting('appointment_form.weekdays')}
                                    validate={isFutureIsoDate}
                                    validationMessage={__('Bitte einen gueltigen Termin auswaehlen.', 'wv-chat-bot')}
                                />
                            </div>
                            <div className="column">
                                <DSGVOCheckbox/>
                            </div>
                            <div className="column">
                                <div className="buttons">
                                    <SubmitButton label={__('Termin anfragen', 'wv-chat-bot')}/>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    );
}


